import React from 'react';
import { Link, useParams } from 'react-router-dom';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import DonutChart from './DonutChart';
import { nextComponentHandlerFunction } from '../utils/helpers/nextComponentHandlerFunction';

/**
 * A reusable menu used within the business model canvas sections to display various steps in the designated context and allow users to navigate between these steps.
 * @param componentIndex
 * @param sectionName
 * @param sectionLocaleName
 * @param menuItems
 * @param common
 * @param rules
 * @param backPath
 * @param progress
 * @returns {Element}
 * @constructor
 */
const BmcMenu = ({
  componentIndex,
  sectionName,
  sectionLocaleName = '',
  menuItems,
  locales: { common },
  rules = false,
  backPath,
  progress,
}) => {
  const { bmcId, id } = useParams();
  const {
    bmc: { view },
  } = useSelector((state) => state);

  let sectionNamePartial = sectionName;

  if (id) {
    sectionNamePartial = sectionNamePartial.replace(':id', id);
  }

  return (
    <nav className="bmc-menu bmc-menu--default" aria-label={sectionLocaleName}>
      <div className="bmc-menu-actions">
        <Link to={nextComponentHandlerFunction(view, backPath)}>
          <button className="bmc-button bmc-button--with-icon">
            <i className="icon-Back" />
            <span>{common.back}</span>
          </button>
        </Link>
      </div>

      <div className="bmc-menu-items margin-bottom-40">
        {menuItems.map((menuItem, index) => (
          <Link
            aria-disabled={rules[index] === false}
            to={`/bmcs/${bmcId}/${sectionNamePartial}/${menuItem.sectionName}`}
            key={index}
            className={classNames('bmc-menu-items-item', {
              'bmc-menu-items-item--active': componentIndex === index,
              'bmc-menu-items-item--disabled': rules[index] === false,
            })}
            onClick={(e) => {
              if (rules && rules[index] === false) e.preventDefault();
            }}
          >
            <div className="bmc-menu-items-item-active-bar" />
            <div
              className={classNames('bmc-menu-items-item-point', {
                'bmc-menu-items-item-point--active': componentIndex === index,
              })}
            />
            <div className="bmc-menu-items-item-title">{menuItem.name}</div>
          </Link>
        ))}
      </div>

      <div className="bmc-menu-progress">
        <DonutChart progress={progress} />
        <div className="bmc-menu-progress-title">{common.sectionProgress}</div>
      </div>
    </nav>
  );
};

export default BmcMenu;
